<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16LKF5B/tc-custom/9781597481663.jpg?1680803535056" alt="This image is the cover for the book The Phantom Diaries, Phantom Diaries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Phantom Diaries, Phantom Diaries
      </h1>
      <p class="bookDescription body article font2">
        <p>If you like Anne Rice, Sarah Maas, and Neil Gaiman's fantasy books, you'll love Kailin Gow's epic fantasies like this one.This is a New Adult Contemporary Paranormal Romance that retells the story of The Phantom of the Opera in modern times with a supernatural twist. In this version of the classic Gaston Leroux Phantom of the Opera, Kailin Gow weaves a tale of love, lust, betrayal, revenge, and hope in this stunning romantic drama. What happens to the Phantom after the tragedy at the Paris Opera House is the basis for this fantastic tale of The Phantom Diaries, loosely based on Gaston Leroux’s classic, The Phantom of the Opera, but with a new tale and a modern twist. This new series for older teens and young adults is told through the eyes of 18 year-old Annette Binoche, who lands a job at the New York Metropolitan Opera House as a seamstress’ assistant only to become the lead singer of the Opera House, with the help of the mysterious, yet highly-seductive Phantom. THE PHANTOM DIARIES SERIES Dark Memories Immortal Darkness PHANTOM DIARIES BEGINNINGS Dark Beginnings Dark Phantom</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kailin Gow
      </h2>
      
      <p class="authorDescription body article">Kailin Gow is a million-selling author who has written and published close to 700 books under her name and various pen names in multiple genres since 2001. She is also an award-winning filmmaker whose films has screened all over the world including Cannes, Los Angeles, London, Paris, Japan, Korea, India, Germany, and Greece. Her books Bitter Frost and PULSE Vampires have been made into video games and is currently filming as featured films. She has been named as the most prolific Asian American author, and has been quoted as the representative for AAPI Heritage Week. Currently, two of her book series, Red Genesis, co-written by Kira G. and her science fiction romance series FADE have been optioned by the Netflix Top 2 Overall film production company Wish Dragon. She is set to write and direct the AAPI diverse cast featured film of Jane Austen’s Pride and Prejudice.  As an actress, she is currently in pre-production to star in 4 AAPI-led films, including her enemies-to-lover novel based on her relative’s ramen factory called Ramen Romance and her real-life experience as an author who has organized some of the biggest book signing events in her novel Love Letters from Las Vegas.  Go to KailinGow.com tfor updates and news.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sparklesoup.com
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?873ad0fe